import React from 'react';
import useStyle from './divider.style';
import { classNames } from 'helpers/style/classNames';

export interface DividerProps {
  height?: 'default' | 'large';
  color?: 'default' | 'light';
  margin?: boolean;
  direction?: 'horizontale' | 'vertical';
  isBottomMenu?: boolean;
}

export const Divider = ({
  color = 'default',
  height = 'default',
  margin = true,
  direction = 'horizontale',
  isBottomMenu = false
}: DividerProps) => {
  const classes = useStyle();

  return (
    <div
      className={classNames(
        [classes.root],
        [
          { condition: height === 'large', classe: classes.large },
          { condition: color === 'light', classe: classes.light },
          { condition: direction === 'vertical', classe: classes.vertical },
          { condition: isBottomMenu === true, classe: classes.bottomMenu },
          { condition: margin, classe: classes.margin }
        ]
      )}
    />
  );
};
